import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EContactChannels, IContactDetails } from 'src/app/shared/models/IContactDetails';
import { ConfigReaderService } from 'src/app/shared/services/util/config.reader.service';
import { SimpleContactModalComponent } from 'src/app/shared/simple-contact-modal/simple-contact-modal.component';

@Component({
    selector: 'app-how-works',
    templateUrl: './how-works.component.html',
    styleUrls: ['./how-works.component.scss']
})
export class HowWorksComponent implements OnInit {

    public loading: boolean;
    private contactDetails: IContactDetails = undefined;
    public enableContactButton: boolean = false;

    constructor(
        private readonly dialogRef: MatDialogRef<HowWorksComponent>,
        private readonly dialog: MatDialog,
        private readonly myConfigReaderService: ConfigReaderService,
    ) { }

    public ngOnInit(): void {
        this.dialogRef.addPanelClass('custom-modal');
        this.myConfigReaderService.getContactDetails().subscribe(data => {
            this.contactDetails = new IContactDetails(data);
            this.enableContactButton = this.contactDetails.enableContactButton();
        });
    }

    public askQuestions(): void {
        const channel: EContactChannels = this.contactDetails.channelToUse();
        if (EContactChannels.EMAIL === channel){
            this.dialog.open( SimpleContactModalComponent, {
                panelClass: 'customDialog',
                data: {
                    contactDetails: this.contactDetails
                }        
            } );
        }else if (EContactChannels.CHAT === channel){
            window.open(this.contactDetails.tawkTo);
        }
    }

}
